// extracted by mini-css-extract-plugin
export var base = "NewsExcerpt-module--base--5e280";
export var content = "NewsExcerpt-module--content--174be";
export var date = "NewsExcerpt-module--date--1c65c";